import get from "lodash/get";

class Celtra {
  static constants = {
    maxZIndex: 2147483644,
  };

  static isCeltra(props, newHtml) {
    return get(props, 'ad.html', '').includes('celtra') || newHtml.includes('celtra');
  }
}

export default Celtra;
